import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {WorkDetail} from "./work-detail";

const WorkDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/user/' + id + '/works');
    }

    return (
        <WorkDetail id={id} onClose={onClose}/>
    )

});

export default WorkDetailPage;